import {
    useState,
    useRef,
    useCallback,
    useMemo
} from 'react';
import {
    Container,
    Content,
    Footer,
    DescriptionText,
    Parameters,
    Title,
    Card,
    ContentConfig,
    Config,
    Load
} from './styled';
import { toast } from 'react-toastify';

export function ConfigParametersTemplates(props) {

    const { template, onChange, close } = props;

    const [loading, setLoading] = useState(false);
    const [parameters, setParameters] = useState([]);

    // Initialize parameters when template changes
    useMemo(() => {
        if (template?.qtd_params !== undefined) {
            setParameters(Array.from({ length: template.qtd_params }, () => ''));
        }
    }, [template?.qtd_params]);
    const formattedText = useMemo(() => {
        if (!template?.text) return '';
        return template.text.replace(/{{(\d+)}}/g, (match, index) => {
            const arrayIndex = parseInt(index) - 1;
            return parameters[arrayIndex] || match;
        });
    }, [template?.text, parameters]);

    const hasEmptyParameters = useMemo(() => {
        return parameters.some(param => !param.trim());
    }, [parameters]);

    const handleInput = useCallback((value, index) => {
        setParameters(prev => prev.map((p, i) => (i === index ? value : p)));
    }, []);

    const handleClick = useCallback(async () => {
        if (loading) return;
        setLoading(true);
        
        try {
            if (hasEmptyParameters) {
            toast.warn(
                    'Por favor! Preencha todos os campos!',
                {
                    position: "top-center",
                    theme: "colored",
                }
            );
                return;
        }
            onChange({
                template,
                textFormatted: formattedText,
                parameters
            });
            close();
        } finally {
            setLoading(false);
    }
    }, [loading, hasEmptyParameters, template, formattedText, parameters, onChange, close]);

    const renderSpanInput = useCallback((index) => (
        <span>
                {`Campo: {{ ${index + 1} }}`}
            </span>
    ), []);

    if (!template) return null;
    return (
        <Container loading={loading ? 1 : 0}>
            <Content>
                <Parameters>
                    <Title>
                        <p>Configurar</p>
                    </Title>
                    <ContentConfig>
                        {parameters.map((param, index) => (
                            <Config key={index}>
                                {renderSpanInput(index)}
                                <div className='group'>
                                    <input
                                        type='text'
                                        value={param}
                                        onChange={(e) => handleInput(e.target.value, index)}
                                        disabled={loading}
                                        placeholder={`Digite o valor para o campo ${index + 1}`}
                                    />
                                </div>
                            </Config>
                        ))}
                    </ContentConfig>
                </Parameters>
                <DescriptionText>
                    <Title>
                        <p>Pré-visualização</p>
                    </Title>
                    <Card>
                        {formattedText}
                    </Card>
                </DescriptionText>
            </Content>
            <Footer loading={loading ? 1 : 0}>
                <button
                    onClick={handleClick}
                    disabled={loading}
                >
                    {loading ? <Load /> : 'Gravar'}
                </button>
            </Footer>
        </Container>
    );
}